import MojitoCore from 'mojito/core';

import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateSimplePopover} from '#core/application/modules/tiles/popover/index.js';

import NEUTRAL_VENUE_INDICATOR from './neutral-venue-indicator.palette-schema.yaml';

const merge = MojitoCore.Presentation.uiStyle.merge;

registerTileSchema(NEUTRAL_VENUE_INDICATOR);

export function generateNeutralVenueIndicator(TILE) {
    return {
        icon: {
            buttonIcon: merge(icon(TILE.NVI_ICON_COLOR), {
                style: {
                    pointerEvents: 'none',
                },
            }),
        },
        tooltip: {
            popup: generateSimplePopover(TILE.NVI_POPOVER_BG, TILE.NVI_POPOVER_BORDER_RADIUS, TILE.NVI_POPOVER_SHADOW),
            textLabel: {
                style: {
                    ...TILE.NVI_POPOVER_TEXT,
                },
            },
            closeButton: {
                buttonIcon: {
                    style: {
                        fill: TILE.NVI_POPOVER_CLOSE_BUTTON_ICON_COLOR,
                    },
                },
            },
        },
    };
}
